import * as Sentry from '@sentry/react';
import { Route as ReactRoute } from '@common/components';

export const Route = Sentry.withSentryRouting(ReactRoute);
